import { render, staticRenderFns } from "./TagsDetail.vue?vue&type=template&id=694eedc3&"
import script from "./TagsDetail.vue?vue&type=script&lang=js&"
export * from "./TagsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports